<template>
  <div class="modal-content border-0 shadow">
    <div class="modal-header pb-0 border-0">
      <div class="col-12">
        <button
          type="button"
          class="btn btn-block d-flex ms-auto"
          style="left: 0; top: 0"
          @click="close"
        >
          <v-icon
            icon="times"
            width="20"
            height="20"
          />
        </button>
      </div>
    </div>
    <div class="modal-body pb-5">
      <div class="col-12 col-md-9 mx-auto">
        <div class="d-flex mx-auto">
          <img
            :src="`${aws}/unicorn-feather.png`"
            class="mx-auto mb-3"
          >
        </div>
        <h5 class="text-center">
          Annuler mon rendez-vous
        </h5>
        <p class="text-center">
          Êtes-vous sûr de vouloir annuler votre rendez-vous ?
        </p>
        <div class="d-flex flex-column">
          <v-loader
            :next="cancelSchedule"
            title="Annuler"
            icon="times-white"
            class="mb-1"
          />
          <v-loader
            :next="close"
            title="Retour à l'accueil"
            color="blue-300"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ui } from '@/mixins';

export default {
  mixins: [ui],
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
  methods: {
    async close() {
      this.ui_showModal(false);
      return Promise.resolve();
    },
    async cancelSchedule() {
      await this.$store.dispatch('client/cancelMeeting');
      this.ui_showModal(false);
    },
  },
};
</script>
